<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">APIs Table</h3>
                    <div class="box-tools pull-right">
                        <a
                            :href="'/apis/new'"
                            class="btn btn-sm btn-primary inner-btn-spacing"
                        >
                            Add New API
                        </a>

                        <button
                            class="btn btn-box-tool"
                            :title="$t('collapse')"
                            type="button"
                            @click="isCollapse = !isCollapse"
                        >
                            <i
                                class="fa"
                                :class="{
                                    'fa-plus': !isCollapse,
                                    'fa-minus': isCollapse,
                                }"
                            />
                        </button>
                    </div>
                </div>

                <vue-slide-up-down :active="isCollapse">
                    <div
                        v-if="!isLoaded"
                        class="box-body with-border clearfix"
                    >
                        <tr>
                            <td>
                                <img
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                            </td>
                        </tr>
                    </div>

                    <div
                        v-else
                        class="box-header with-border"
                    >
                        <div class="row">
                            <div class="col-xs-12 col-sm-5 col-lg-4 mt5">
                                <FormSelect
                                    v-model="filter.account"
                                    :options="accounts"
                                    :placeholder="`${$t('filterBy')} ${$t('api.account.account')}`"
                                    searchable
                                    allowEmpty
                                    closeOnSelect
                                    :disabled="isFilterAccountDisabled"
                                    trackBy="id"
                                    label="name"
                                />
                            </div>

                            <div class="col-xs-12 col-sm-5 col-lg-4 mt5">
                                <FormSelect
                                    v-model="filter.tags"
                                    :options="tags"
                                    :placeholder="`${$t('filterBy')} ${$t('api.tag.tags')}`"
                                    searchable
                                    allowEmpty
                                    multiple
                                    :disabled="isFilterTagsDisabled"
                                    trackBy="id"
                                    label="name"
                                />
                            </div>

                            <div class="col-xs-12 col-sm-2 col-lg-4 mt5">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    :disabled="isLoading"
                                    @click="submitFilter"
                                >
                                    <i
                                        v-if="isLoading"
                                        class="fa fa-refresh fa-spin"
                                    />
                                    <span>{{ $t('filter') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <ApisTable
                        v-show="isLoaded"
                        ref="apisTable"
                        :orderBy="'active'"
                        :providerId="providerId"
                        :isLoading="isLoading"
                        @loaded="onLoaded"
                    />
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import ApisTable from '@/components/apis/ApisTable';
import EventBus from '@/event-bus';

export default {
    components: {
        ApisTable,
    },
    props: {
        providerId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoaded: false,
            isLoading: false,
            isCollapse: true,
            apis: [],
            accounts: [],
            tags: [],
            filter: {
                account: undefined,
                tags: undefined,
            },
        };
    },
    computed: {
        isFilterAccountDisabled() {
            return !this.apis.length || !this.accounts.length || this.isLoading;
        },

        isFilterTagsDisabled() {
            return !this.apis.length || !this.tags.length || this.isLoading;
        },
    },
    methods: {
        onLoaded({ apis, accounts, tags }) {
            this.accounts = accounts;
            this.apis = apis;
            this.tags = tags;
            this.isLoaded = true;
            this.isLoading = false;

            if (this.$route.query['filter[accountId]']) {
                this.filter.account = this.accounts
                    .find((element) => element.id === Number(this.$route.query['filter[accountId]']));
            }

            if (this.$route.query['filter[tags]']) {
                let currentTags = Array.isArray(this.$route.query['filter[tags]'])
                    ? this.$route.query['filter[tags]']
                    : [this.$route.query['filter[tags]']];

                currentTags = currentTags.map((e) => Number(e));
                this.filter.tags = this.tags.filter((e) => currentTags.includes(e.id));
            }
        },
        async submitFilter() {
            const accountId = this.filter.account && (this.filter.account.id || '');
            const tags = this.filter.tags && this.filter.tags.length && this.filter.tags.map((e) => e.id);

            let query = {};
             query.page = 1;

            if (accountId) {
                query['filter[accountId]'] = accountId;
            }

            if (tags) {
                query['filter[tags]'] = tags;
            }

            this.$router.push({
                path: this.getPath(),
                query,
            }).catch(() => {});

            EventBus.$emit('relodList');
        },
        getPath() {
            return this.$route.path;
        },
    },
};
</script>
